import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { addJob, deleteJob, getJobs, updateJob } from "./jobsAPI";

const initialState = {
  isLoading: false,
  isError: false,
  jobs: [],
  error: "",
  editing: {},
};

export const fetchJobs = createAsyncThunk("jobs/fetchJobs", async () => {
  const jobs = await getJobs();

  return jobs;
});

export const createJob = createAsyncThunk("jobs/createJob", async (jobObj) => {
  const job = await addJob(jobObj);

  return job;
});

export const editJob = createAsyncThunk(
  "jobs/editJob",
  async ({ id, jobObj }) => {
    const job = await updateJob(id, jobObj);

    return job;
  }
);

export const removeJob = createAsyncThunk("jobs/removeJob", async (id) => {
  const job = await deleteJob(id);

  return job;
});

const jobsSlice = createSlice({
  name: "jobs",
  initialState,
  reducers: {
    editActive: (state, action) => {
      state.editing = action.payload;
    },
    editInActive: (state, action) => {
      state.editing = {};
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchJobs.pending, (state, action) => {
        state.isLoading = true;
        state.isError = false;
      })
      .addCase(fetchJobs.fulfilled, (state, action) => {
        state.isLoading = false;
        state.isError = false;
        state.jobs = action.payload;
        state.error = "";
      })
      .addCase(fetchJobs.rejected, (state, action) => {
        state.isLoading = false;
        state.isError = true;
        state.jobs = [];
        state.error = action.error?.message;
      })
      .addCase(createJob.pending, (state, action) => {
        state.isLoading = true;
        state.isError = false;
      })
      .addCase(createJob.fulfilled, (state, action) => {
        state.isLoading = false;
        state.isError = false;
        state.jobs.push(action.payload);
        state.error = "";
      })
      .addCase(createJob.rejected, (state, action) => {
        state.isLoading = false;
        state.isError = true;
        state.error = action.error?.message;
      })
      .addCase(editJob.pending, (state, action) => {
        state.isLoading = true;
        state.isError = false;
      })
      .addCase(editJob.fulfilled, (state, action) => {
        state.isLoading = false;
        state.isError = false;
        const indexToUpdate = state.jobs.findIndex(
          (j) => j.id === action.payload.id
        );
        state.jobs[indexToUpdate] = action.payload;
        state.error = "";
      })
      .addCase(editJob.rejected, (state, action) => {
        state.isLoading = false;
        state.isError = true;
        state.error = action.error?.message;
      })
      .addCase(removeJob.pending, (state, action) => {
        state.isLoading = true;
        state.isError = false;
      })
      .addCase(removeJob.fulfilled, (state, action) => {
        state.isLoading = false;
        state.isError = false;
        state.error = "";
        state.jobs = state.jobs.filter((j) => j.id !== action.meta.arg);
      })
      .addCase(removeJob.rejected, (state, action) => {
        state.isLoading = false;
        state.isError = true;
        state.error = action.error?.message;
      });
  },
});

export default jobsSlice.reducer;
export const { editActive, editInActive } = jobsSlice.actions;
